import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, authApi } from "@/context/AuthContext";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser, loadSaved } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    const path = window.location.pathname || "/";
    (async () => {
      try {
        const r = await authApi.post("/auth/session", { session_id: sessionId });
        setUser(r.data);
        loadSaved();
      } catch (e) {
        console.error("Auth session exchange failed:", e?.response?.status || e?.message || e);
      }
      navigate(path, { replace: true });
    })();
  }, [navigate, setUser, loadSaved]);

  return (
    <div className="min-h-screen bg-night flex items-center justify-center">
      <p className="font-mono-label text-white/40" data-testid="auth-callback-loading">SIGNING YOU IN...</p>
    </div>
  );
}
